import { useRef } from "react";

import Star from "../Star";
import Reaction from "./reaction";
import Helpers from "../../commons/helpers";
import useWindowDimensions from "../../commons/dememsions";

import { IReaction } from "../../commons/interfaces";


interface IProps {
    userId: string;
    fullName: string;
    discussionValue: string;
    item: any;
    reactionIcon: IReaction[];
}

const Content = ({ userId, fullName, discussionValue, item, reactionIcon }: IProps) => {
    const { width } = useWindowDimensions();
    const wrapperRef = useRef<any>(null);
    return (
        <div
            ref={wrapperRef}
            className="cr-content-comment-box"
            style={{
                maxWidth: width - 16 - 32 - 32 - 32 - 50 - 16 - 64,
            }}
        >
            <span className="cr-comment-name">
                {/* <a href={`@${userId}`} target="_blank"> */}
                {fullName}
                {/* </a> */}
                <span>({Helpers.leftDate(Number(item.timeComment || 0))})</span>
                {item?.rating && (
                    <Star
                        value={Number(item?.rating?.ratingSurveyAnswers[0]?.userAnswer)}
                        disabled={true}
                        style={{ height: "30px" }}
                        labelStyle={{ fontSize: "20px" }}
                    />
                )}
            </span>
            <p className="cr-comment-text">{discussionValue}</p>
            {/* <Reaction userReactions={item?.userReactions || []} reactionIcon={reactionIcon || []} /> */}
        </div>
    );
};

export default Content;
